module.exports = __webpack_public_path__ + "img/profile-icon.6f3eef21.svg";